import { downloadText } from "@/features/preflight/lib/download";

import type { PersonaOpportunityDisplayRow } from "./persona-opportunity-row-model";
import { formatPercent } from "./persona-opportunity-row-model";
import { formatCsvExportCell } from "./persona-csv-cells.js";

const CSV_HEADERS = [
  "Persona",
  "Angle",
  "Status",
  "Creatives",
  "Competitors running",
  "Competitors total",
  "Stick rate",
  "Duplicated",
  "My investment share",
  "Market investment share",
  "Investment index",
  "Competitor",
  "Supporting ad URL",
  "Supporting ad days live",
  "Supporting ad duplications",
] as const;

export interface PersonaOpportunityExportRow {
  personaTitle: string;
  row: PersonaOpportunityDisplayRow;
}

function statusLabel(status: PersonaOpportunityDisplayRow["status"]): string {
  switch (status) {
    case "NEW":
      return "New";
    case "SCRIPTS_GENERATED":
      return "Scripts generated";
    case "BRIEFS_GENERATED":
      return "Briefs generated";
    case "SCRIPTS_AND_BRIEFS_GENERATED":
      return "Scripts + briefs generated";
    case "SENT_TO_VENDOR":
      return "Sent to production partner";
    default:
      return status;
  }
}

export function buildPersonaOpportunitiesCsv(rows: PersonaOpportunityExportRow[]): string {
  const lines = [
    CSV_HEADERS.map((header) => formatCsvExportCell(header)).join(","),
    ...rows.map(({ personaTitle, row }) =>
      [
        formatCsvExportCell(personaTitle),
        formatCsvExportCell(row.angle),
        formatCsvExportCell(statusLabel(row.status)),
        formatCsvExportCell(row.creativesCount),
        formatCsvExportCell(row.competitorsRunningCount),
        formatCsvExportCell(row.competitorsTotal),
        formatCsvExportCell(formatPercent(row.stickRatePct)),
        formatCsvExportCell(formatPercent(row.duplicatedPct)),
        formatCsvExportCell(formatPercent(row.myInvestmentSharePct)),
        formatCsvExportCell(formatPercent(row.marketInvestmentSharePct)),
        formatCsvExportCell(row.investmentIndex),
        formatCsvExportCell(row.competitorName),
        formatCsvExportCell(row.mediaUrl),
        formatCsvExportCell(row.daysLive),
        formatCsvExportCell(row.duplications),
      ].join(","),
    ),
  ];
  return lines.join("\n");
}

export function exportPersonaOpportunitiesCsv(
  rows: PersonaOpportunityExportRow[],
  filename: string,
): void {
  downloadText(buildPersonaOpportunitiesCsv(rows), filename, "text/csv;charset=utf-8");
}
